import React, { useEffect, useState } from "react";
import { gettripstop } from "../../../services/TransportService";
import { Spinner } from "react-bootstrap";
import { FaRoute } from "react-icons/fa";
const Tripstop = ({ id, stopdata, setStopdata, routeName }) => {
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrormMsg] = useState("");
  useEffect(() => {
    if (!stopdata) {
      setLoading(true);
      gettripstop(id)
        .then((res) => {
          setStopdata(res?.data?.data || []);
        })
        .catch((err) => {
          setErrormMsg(
            err?.response?.data?.message ||
              err?.response?.data?.error ||
              "Try agian later"
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id]);
  if (loading) {
    return (
      <div className="text-center">
        <Spinner animation="border" className="mt-3" />
      </div>
    );
  }
  return (
    <div>
      {errorMsg ? (
        <div className="alert alert-danger">{errorMsg}</div>
      ) : stopdata?.length > 0 ? (
        <>
          <div className="d-flex align-items-center gap-2 mb-3">
            <FaRoute className="text-primary" size={20} />
            <h5 className="m-0 text-dark">{routeName || "N/A"}</h5>
          </div>
          <div className="route-stop-list p-2">
            {stopdata?.map((stop, index) => (
              <div key={index} className="route-stop">
                <div className="timeline">
                  <span className="stop-pin">
                    <span className="stop-order">{index + 1}</span>
                  </span>
                  {index !== stopdata?.length - 1 && <span className="line" />}
                </div>
                <div className="stop-data">
                  <span className="stop-name" style={{fontSize:'0.9rem'}}>
                    {stop?.stop?.name}
                    <br></br>
                    <span
                      className="badge text-bg-info-soft"
                      style={{ fontSize: "0.7rem" }}
                    >
                      Arrive:{stop?.reach_time ? stop?.reach_time : "N/A"}
                    </span>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <p className="text-danger text-center">No stops found.</p>
      )}
    </div>
  );
};

export default Tripstop;
